import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  > div {
    flex: 1;
    flex-direction: column;
    text-align: center;
    padding: 0 0.6rem;
    span {
      font-size: 1.3rem;
      color: ${(props) => props.theme.dimGrey};
      margin: 0 auto;
      text-transform: uppercase;
    }
  }
`;

export const Probability = styled.h4<{ highlight: boolean | null }>`
  color: ${(props) =>
    props.highlight ? props.theme.formWin : props.theme.black};
  margin: 0 auto 0.6rem auto;
  font-size: 1.3rem;
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  > button:first-of-type {
    margin-left: 0;
  }
  > button:last-of-type {
    margin-right: 0;
  }

  span {
    text-transform: capitalize;
  }
`;
